document.addEventListener('DOMContentLoaded', function () {
  var totalSoldEl = document.getElementById('TotalSold');
  var hoursEl = document.getElementById('InHours');
  var fireEl = document.querySelector('.flash-fire');
  if (!totalSoldEl || !hoursEl) return;
  var minQty = 10;
  var maxQty = 50;
  var minTime = 24;
  var maxTime = 24;
  var pathParts = window.location.pathname.split('/');
  var productHandle = pathParts[pathParts.length - 1] || 'default';
  var storageKey = 'flashSold_' + productHandle;
  var qty = localStorage.getItem(storageKey);
  if (!qty) {
    qty = Math.floor(Math.random() * (maxQty - minQty + 1)) + minQty;
    localStorage.setItem(storageKey, qty);
  }
  totalSoldEl.textContent = qty;

  var time = Math.floor(Math.random() * (maxTime - minTime + 1)) + minTime;
  hoursEl.textContent = time;
  setInterval(function () {
    if (!fireEl) return;
    fireEl.style.opacity = fireEl.style.opacity === '0' ? '1' : '0';
  }, 700);
});
